import React from 'react';
import { IIconProps } from './utils';

export const History = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M14.6668 8C14.6668 4.68629 12.0137 2 8.7409 2C5.46811 2 2.81498 4.68629 2.81498 8M2.81498 8L1.3335 6.5M2.81498 8L4.66683 6.875M4.24152 11.9048C5.32835 13.1874 6.9409 14 8.7409 14C11.0676 14 13.0812 12.6423 14.0509 10.6667" stroke={fill} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.6665 5.66663V8.52856C8.6665 8.61696 8.70162 8.70174 8.76413 8.76426L9.69091 9.69103" stroke={fill} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
